import axios from "axios";
import React, { useEffect, useState } from "react";
import { CUST_ID } from "../../constants";
import CancelRequest from "./CancelRequest";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import ReactModal from "react-modal";
import RescheduleAppointment from "./RescheduleAppointment";
import useThemeColors from "../vehicle/ThemeColors";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import BookingTabs from "./BookingTabs";
import FeedbackModal from "./FeedbackModal";
import "./appointment.scss";
import { Button, Stack } from "@mui/material";

const Appointment = () => {
    const [bookingData, setBookingData] = useState([]);
    const [openCancelServiceRequestModal, setOpenCancelServiceRequestModal] =
        useState(false);
    const [openRescheduleModal, setOpenRescheduleModal] = useState(false);

    const [selectedTab, setSelectedTab] = useState<any>("booking");
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

    const [getServiceRequestData, setGetServiceRequestData] = useState({});
    const [getServiceData, setGetServiceData] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const customerid = localStorage.getItem(CUST_ID);

    console.log(bookingData, "bookingData")

    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const token = localStorage.getItem("customer-token");

    const fetchServiceRequestAPI = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/appointment-list/?customer_id=${customerid}&status=${selectedTab}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setBookingData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedTab != "booking") {
            fetchServiceRequestAPI();
        }
    }, [selectedTab]);

    const fetchServiceBookingAPI = async () => {
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/?customer_id=${customerid}&status=pending,cancelled`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setBookingData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    useEffect(() => {
        if (selectedTab === "booking") {
            fetchServiceBookingAPI();
        }
    }, [selectedTab]);

    const closeModal = () => {
        setOpenCancelServiceRequestModal(false);
        setOpenRescheduleModal(false);
    };

    const { selectedColor } = useThemeColors();

    const customModalStyles1: ReactModal.Styles = {
        content: {
            top: "50%",
            left: screenWidth < 900 ? "40%" : "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-40%, -50%)",
            width: screenWidth < 900 ? "90%" : "30%", // 👈 this line
            border: "none",
            boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
            borderRadius: "40px",
            padding: "5px",
        },
    };
    const rescheduleServiceHandler = (el: any) => {
        console.log("Original data:", el);
        
        // Extract booking_request and other top-level fields
        const { booking_request, ...appointmentData } = el;
        
        // Merge the data with proper structure
        const formattedData = {
            ...appointmentData,  // Keep all top-level appointment data first
            ...(booking_request || {}),  // Then spread booking_request fields
            // Ensure workshop_details is properly set
            workshop_details: booking_request?.workshop_details || el.workshop_details
        };
    
        console.log("Formatted data:", formattedData);
        
        if (selectedTab === "scheduled") {
            setGetServiceRequestData(formattedData);
            setOpenRescheduleModal(true);
        } else {
            setGetServiceRequestData(formattedData);
            setOpenRescheduleModal(true);
        }
    };
   


    const cancelRequestHandler = (el) => {
        setGetServiceRequestData(el)
        setOpenCancelServiceRequestModal(true)

    }

    console.log(getServiceData, "serviceData")
    return (
        <div
            className="customer-vehicle-info__table-container"
        >
            {/* <FilterDropdown setLiftingStatus={setLiftingStatus}/> */}
            <BookingTabs
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
            />

            <div
                className="table-view"
                style={{ width: "100%", overflow: "scroll" }}
            >
                <table className="customer-vehicle-info__table">
                    <thead>
                        <tr >
                            <th>
                                {selectedTab === "booking"
                                    ? "Request"
                                    : "Appointment"}{" "}
                                id
                            </th>
                            <th>Service </th>
                            <th>Sub service</th>
                            <th>Service date</th>
                            <th>Workshop</th>
                            <th>Workshop email</th>
                            <th style={{ whiteSpace: "nowrap" }}>
                                Workshop address
                            </th>
                            <th>Status</th>
                            {(selectedTab === "completed" ||
                                selectedTab === "booking" ||
                                selectedTab === "scheduled") && (
                                    <th>Actions</th>
                                )}
                            { }
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={9}
                                    style={{
                                        textAlign: "center",
                                        padding: "20px",
                                    }}
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : bookingData?.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={9}
                                    style={{
                                        textAlign: "center",
                                        padding: "20px",
                                    }}
                                >
                                    No appointments found
                                </td>
                            </tr>
                        ) : (
                            bookingData?.map((vehicle) => (
                                <tr
                                    key={vehicle.id}
                                    className="vehicle-info__row"
                                    style={{ fontFamily: "Karbon-medium" }}
                                >
                                    <td className="customer-vehicle-info__cell">
                                        {selectedTab === "booking"
                                            ? vehicle?.id : selectedTab === "scheduled" ? vehicle?.appointment_id : selectedTab === "completed" ? vehicle?.appointment_id : selectedTab === "scheduled" ? vehicle?.appointment_id
                                                : vehicle?.appointment_id}
                                    </td>
                                    <td className="customer-vehicle-info__cell">
                                        {selectedTab === "booking"
                                            ? vehicle?.service_details?.map((service: any, index: number) => (
                                                <div key={index}>
                                                    {index + 1}. {service?.name}
                                                </div>
                                            ))
                                            : vehicle?.booking_request?.service_details?.map((service: any, index: number) => (
                                                <div key={index}>
                                                    {index + 1}. {service?.name}
                                                </div>
                                            ))}
                                    </td>

                                    <td className="customer-vehicle-info__cell">
                                        {selectedTab === "booking"
                                            ? vehicle?.service_details?.flatMap((service: any) =>
                                                service?.sub_services?.map((sub: any, index: number) => (
                                                    <div key={`${service.id}-${index}`}>
                                                        {index + 1}. {sub?.name}
                                                    </div>
                                                ))
                                            )
                                            : vehicle?.booking_request?.service_details?.flatMap((service: any) =>
                                                service?.sub_services?.map((sub: any, index: number) => (
                                                    <div key={`${service.id}-${index}`}>
                                                        {index + 1}. {sub?.name}
                                                    </div>
                                                ))
                                            )}
                                    </td>

                                    <td className="customer-vehicle-info__cell">
                                        {(selectedTab === "scheduled" || selectedTab === "cancelled" )
                                            ? (() => {
                                                try {
                                                    const dateStr = vehicle?.appointment_date; // e.g., '2025-09-29T13:15:00Z'
                                                    if (!dateStr) return 'N/A';
                                                    
                                                    const parts = dateStr.split('T');
                                                    if (parts.length < 2) return 'Invalid date format';
                                                    
                                                    const [datePart, timePart] = parts;
                                                    const dateParts = datePart?.split('-') || [];
                                                    if (dateParts.length < 3) return 'Invalid date format';
                                                    
                                                    const [year, month, day] = dateParts;
                                                    const timeComponents = (timePart?.split('.')[0] || '').split(':');
                                                    if (timeComponents.length < 2) return 'Invalid time format';
                                                    
                                                    const [hours, minutes] = timeComponents;
                                                    const hoursNum = parseInt(hours, 10) || 0;
                                                    
                                                    // Convert to 12-hour format
                                                    let hour12 = hoursNum % 12;
                                                    hour12 = hour12 === 0 ? 12 : hour12;
                                                    const period = hoursNum >= 12 ? 'PM' : 'AM';
                                                    
                                                    return `${day}/${month}/${year}, ${hour12.toString().padStart(2, '0')}:${minutes} ${period}`;
                                                } catch (error) {
                                                    console.error('Error parsing date:', error);
                                                    return 'Invalid date';
                                                }
                                              })()
                                            : formatDate(
                                                selectedTab === "booking"
                                                    ? vehicle?.service_date
                                                    : vehicle?.appointment_date
                                            )
                                        }
                                    </td>
                                    <td className="customer-vehicle-info__cell">
                                        {selectedTab === "booking"
                                            ? vehicle?.workshop_details
                                                ?.workshopName
                                            : vehicle?.booking_request
                                                ?.workshop_details?.name}
                                    </td>
                                    <td
                                        className="customer-vehicle-info__cell"
                                        style={{
                                            width: "200px",
                                            maxWidth: "200px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        title={
                                            selectedTab === "booking"
                                                ? vehicle?.workshop_details
                                                    ?.workShopAdministrationEmail
                                                : vehicle?.booking_request
                                                    ?.workshop_details?.email
                                        }
                                    >
                                        {selectedTab === "booking"
                                            ? vehicle?.workshop_details
                                                ?.workShopAdministrationEmail
                                            : vehicle?.booking_request
                                                ?.workshop_details?.email}
                                    </td>
                                    <td
                                        className="customer-vehicle-info__cell"
                                        style={{
                                            width: "200px",
                                            maxWidth: "200px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        title={
                                            selectedTab === "booking"
                                                ? vehicle?.workshop_details
                                                    ?.address
                                                : vehicle?.booking_request
                                                    ?.workshop_details
                                                    ?.address
                                        }
                                    >
                                        {selectedTab === "booking"
                                            ? vehicle?.workshop_details?.address
                                            : vehicle?.booking_request
                                                ?.workshop_details?.address}
                                    </td>
                                    <td
                                        className="customer-vehicle-info__cell"
                                        style={{
                                            color:
                                                vehicle?.status === "cancelled"
                                                    ? "red"
                                                    : vehicle?.status ===
                                                        "scheduled"
                                                        ? "green"
                                                        : "black",
                                        }}
                                    >
                                        {capitalizeFirstLetter(vehicle?.status)}
                                    </td>
                                    {(selectedTab === "completed" ||
                                        selectedTab === "booking" ||
                                        selectedTab === "scheduled") && (
                                            <td style={{ textAlign: "center" }}>
                                                {selectedTab !== "completed" ? (
                                                    <>
                                                        {!(selectedTab === "booking" && vehicle?.status === "cancelled") && (
                                                            <span
                                                                style={{ marginRight: "10px" }}
                                                                onClick={() => cancelRequestHandler(vehicle)}
                                                            >
                                                                <i
                                                                    className="bi bi-x-circle"
                                                                    style={{ color: "black", fontSize: "18px" }}
                                                                ></i>
                                                            </span>
                                                        )}
                                                        {vehicle?.status === "cancelled" ? "" :
                                                            <span onClick={() => rescheduleServiceHandler(vehicle)}>
                                                                <i
                                                                    className="bi bi-arrow-clockwise"
                                                                    style={{ color: "black", fontSize: "18px" }}
                                                                ></i>
                                                            </span>
                                                        }

                                                    </>
                                                ) : (
                                                    !vehicle?.customer_feedback && (
                                                        <button
                                                            onClick={() => {
                                                                setFeedbackModalOpen(true);
                                                                setGetServiceData(vehicle);
                                                            }}
                                                            style={{
                                                                border: "1px solid orange",
                                                                borderRadius: "30px",
                                                                padding: "10px",
                                                                background: "#e74c3c",
                                                                color: "white",
                                                            }}
                                                        >
                                                            Feedback
                                                        </button>
                                                    )
                                                )}
                                            </td>
                                        )}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="card-view">
                {bookingData?.length === 0 && !loading ? (
                    <p
                        style={{
                            textAlign: "center",
                            padding: "20px",
                            fontFamily: "Atlassian Sans Ext",
                        }}
                    >
                        No appointments found
                    </p>
                ) : loading ? (
                    <p
                        style={{
                            textAlign: "center",
                            padding: "20px",
                            fontFamily: "Karbon-medium",
                        }}
                    >
                        Loading...
                    </p>
                ) : (
                    bookingData?.map((vehicle) => {
                        const isBooking = selectedTab === "booking";
                        const scheduled = selectedTab === "scheduled"
                        const booking = isBooking
                            ? vehicle
                            : vehicle?.booking_request;
                        const serviceDetails = booking?.service_details?.[0];
                      
                        return (
                            <div key={vehicle.id} className="booking-card">
                                <p>
                                    <span className="booking-card-heading">
                                        {isBooking ? "Request" : "Appointment"}
                                        ID:
                                    </span>{" "}
                                    <span className="booking-card-value">

                                        {isBooking ? vehicle?.id : scheduled ? vehicle?.appointment_id : booking?.id}
                                    </span>
                                </p>
                                <p>
                                    <span className="booking-card-heading">Service: </span>{" "}
                                    <span className="booking-card-value">

                                        {serviceDetails?.name}
                                    </span>
                                </p>
                                <p>
                                    <span className="booking-card-heading">Sub service: </span>{" "}
                                    <span className="booking-card-value">

                                        {serviceDetails?.sub_services?.[0]?.name}
                                    </span>
                                </p>
                                <p>
                                    <span className="booking-card-heading">Service date: </span>{" "}
                                    <span className="booking-card-value">


                                    {selectedTab === "scheduled" 
                                            ? (() => {
                                                try {
                                                    const dateStr = vehicle?.appointment_date; // e.g., '2025-09-29T13:15:00Z'
                                                    if (!dateStr) return 'N/A';
                                                    
                                                    const parts = dateStr.split('T');
                                                    if (parts.length < 2) return 'Invalid date format';
                                                    
                                                    const [datePart, timePart] = parts;
                                                    const dateParts = datePart?.split('-') || [];
                                                    if (dateParts.length < 3) return 'Invalid date format';
                                                    
                                                    const [year, month, day] = dateParts;
                                                    const timeComponents = (timePart?.split('.')[0] || '').split(':');
                                                    if (timeComponents.length < 2) return 'Invalid time format';
                                                    
                                                    const [hours, minutes] = timeComponents;
                                                    const hoursNum = parseInt(hours, 10) || 0;
                                                    
                                                    // Convert to 12-hour format
                                                    let hour12 = hoursNum % 12;
                                                    hour12 = hour12 === 0 ? 12 : hour12;
                                                    const period = hoursNum >= 12 ? 'PM' : 'AM';
                                                    
                                                    return `${day}/${month}/${year}, ${hour12.toString().padStart(2, '0')}:${minutes} ${period}`;
                                                } catch (error) {
                                                    console.error('Error parsing date:', error);
                                                    return 'Invalid date';
                                                }
                                              })()
                                            : formatDate(
                                                selectedTab === "booking"
                                                    ? vehicle?.service_date
                                                    : vehicle?.appointment_date
                                            )
                                        }
                                    </span>

                                </p>
                                <p>
                                    <span className="booking-card-heading">Workshop: </span>
                                    <span className="booking-card-value">

                                        {isBooking
                                            ? vehicle?.workshop_details
                                                ?.workshopName
                                            : booking?.workshop_details?.name}
                                    </span>

                                </p>
                                <p>
                                    <span className="booking-card-heading">Workshop email: </span>
                                    <span className="booking-card-value">
                                        {isBooking
                                            ? vehicle?.workshop_details
                                                ?.workShopAdministrationEmail
                                            : booking?.workshop_details?.email}
                                    </span>
                                </p>
                                <p>
                                    <span className="booking-card-heading">Workshop address: </span>
                                    <span className="booking-card-value">

                                        {isBooking
                                            ? vehicle?.workshop_details?.address
                                            : booking?.workshop_details?.address}
                                    </span>

                                </p>
                                <p>
                                    <span className="booking-card-heading">Status: </span>
                                    <span className="booking-card-value"
                                        style={{
                                            color:
                                                vehicle?.status === "cancelled"
                                                    ? "red"
                                                    : vehicle?.status ===
                                                        "scheduled"
                                                        ? "green"
                                                        : "black",
                                        }}
                                    >
                                        {capitalizeFirstLetter(vehicle?.status)}
                                    </span>
                                </p>

                                <div>

                                    {vehicle?.customer_feedback && (
                                        <p>
                                            <span className="booking-card-heading">Customer feedback: </span>
                                            <span className="booking-card-value">

                                                {capitalizeFirstLetter(vehicle?.customer_feedback)}
                                            </span>
                                        </p>
                                    )}
                                </div>
                                {vehicle?.status !== "completed" && vehicle?.status !== "cancelled" && (
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            onClick={() => cancelRequestHandler(vehicle)}
                                            variant="outlined"
                                            sx={{
                                                borderRadius: "20px",
                                                padding: "10px 20px",
                                                fontWeight: "bold",
                                                textTransform: "none",
                                                color: "#d32f2f",
                                                borderColor: "#d32f2f",
                                                width: "100%",
                                                "&:hover": {
                                                    backgroundColor: "#ffe6e6",
                                                    borderColor: "#d32f2f",
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={() => rescheduleServiceHandler(vehicle)}
                                            variant="outlined"
                                            sx={{
                                                borderRadius: "20px",
                                                padding: "10px 20px",
                                                fontWeight: "bold",
                                                textTransform: "none",
                                                color: "#1976d2",
                                                borderColor: "#1976d2",
                                                width: "100%",
                                                "&:hover": {
                                                    backgroundColor: "#e3f2fd",
                                                    borderColor: "#1976d2",
                                                },
                                            }}
                                        >
                                            Reschedule
                                        </Button>
                                    </Stack>
                                )}



                                {selectedTab === "completed" &&
                                    !vehicle?.customer_feedback && (
                                        <button
                                            onClick={() => {
                                                setFeedbackModalOpen(true);
                                                setGetServiceData(vehicle);
                                            }}
                                            style={{
                                                border: "1px solid orange",
                                                borderRadius: "30px",
                                                padding: "10px",
                                                background: "#e74c3c",
                                                color: "white",
                                            }}
                                        >
                                            Feedback
                                        </button>
                                    )}
                            </div>
                        );
                    })
                )}
            </div>
            {openCancelServiceRequestModal && (
                <CancelRequest
                    onClose={closeModal}
                    serviceData={getServiceRequestData}
                    fetchServiceRequestAPI={fetchServiceRequestAPI}
                    selectedTab={selectedTab}
                />
            )}

            <ReactModal
                isOpen={openRescheduleModal}
                onRequestClose={closeModal}
                style={customModalStyles1}
            >
                <RescheduleAppointment
                    closeModal={closeModal}
                    refetch={fetchServiceRequestAPI}
                    refetch2={fetchServiceBookingAPI}
                    requestedId={getServiceRequestData}
                    selectedTab={selectedTab}
                />
            </ReactModal>

            <FeedbackModal
                show={feedbackModalOpen}
                onClose={() => setFeedbackModalOpen(false)}
                setOpenModal={closeModal}
                getServiceData={getServiceData}
                fetchServiceRequestAPI={fetchServiceRequestAPI}
            />
        </div>
    );
};

export default Appointment;